import { createRouter, createWebHashHistory } from 'vue-router'
import { useRoute } from 'vue-router'

import { useAuth } from '@/composables/useAuth'; 
const route = useRoute()

const { getUser, isAuthenticated, hasAuthorization } = useAuth()

const routes = [
  {
    name: 'login',
    path: '/login',
    component: () => import('../views/Login.vue')
  },
  {
    name: 'forgot-password',
    path: '/forgot_password',
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    name: 'reset-password',
    path: '/reset-password',
    component: () => import('../views/ResetPassword.vue')
  },
  {
    name: 'confirmacion',
    path: '/confirmacion/:uri',
    component: () => import('../views/ajustes/Confirmation.vue')
  },
  {
    name: 'documentacion',
    path: '/:uuid/documentacion',
    component: () => import('../views/DownloadDocuments.vue')
  },
  {
    name: 'vc-customer',
    path: '/vc-customer',
    component: () => import('../views/stream/Customer.vue')
  },
  {
    name: 'vc-expert',
    path: '/vc-expert',
    component: () => import('../views/stream/Expert.vue'),
    meta: { requiresRole: ['Ajustador', 'Administrador'] }
  },
  {
    name: 'signature',
    path: '/signature/:id',
    component: () => import('../views/Signature.vue'),
    meta: { requiresRole: ['Ajustador'] }
  },
  {
    path: '/',
    component: () => import('../views/layouts/BaseLayout.vue'), // layout base
    redirect: '/siniestros', 
    children: [
      {
        name: 'cuenta',
        path: 'cuenta',
        component: () => import('../views/administracion/usuarios/Account.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'ajustes',
        path: 'siniestros',
        component: () => import('../views/ajustes/Index.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'ajustes.upsert',
        path: 'siniestro/:id?',
        component: () => import('../views/ajustes/UpsertWrapper.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'administracion',
        path: 'administracion',
        component: () => import('../views/administracion/Menu.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'usuarios',
        path: 'usuarios',
        component: () => import('../views/administracion/usuarios/Index.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'usuarios.upsert',
        path: 'usuario/:id?',
        component: () => import('../views/administracion/usuarios/Upsert.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'marcas',
        path: 'marcas',
        component: () => import('../views/administracion/marcas/Index.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'marcas.upsert',
        path: 'marca/:id?',
        component: () => import('../views/administracion/marcas/Upsert.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'modelos',
        path: 'modelos',
        component: () => import('../views/administracion/modelos/Index.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'modelos.upsert',
        path: 'modelo/:id?',
        component: () => import('../views/administracion/modelos/Upsert.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'catalogos/decline',
        path: 'motivos_rechazo',
        component: () => import('../views/administracion/catalogos/motivos_rechazo/Index.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'catalogos/decline.upsert',
        path: 'motivo_rechazo/:id?',
        component: () => import('../views/administracion/catalogos/motivos_rechazo/Upsert.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'catalogos/not-applicable',
        path: 'motivos_no_procedencia',
        component: () => import('../views/administracion/catalogos/motivos_no_procedencia/Index.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'catalogos/not-applicable.upsert',
        path: 'motivo_no_procedencia/:id?',
        component: () => import('../views/administracion/catalogos/motivos_no_procedencia/Upsert.vue'),
        meta: { requiresRole: ['Administrador'] }
      },
      {
        name: 'aseguradoras',
        path: '/aseguradoras',
        component: () => import('../views/administracion/aseguradoras/Index.vue'),
        meta: { requiresRole: ['Agente Venta'] }
      },
      {
        name: 'aseguradoras.upsert',
        path: 'aseguradora/:id?',
        component: () => import('../views/administracion/aseguradoras/Upsert.vue'),
        meta: { requiresRole: ['Agente Venta'] }
      },
      {
        name: 'unauthorized',
        path: 'unauthorized',
        component: () => import('../views/Unauthorized.vue'),
        meta: { requiresAuth: true }
      },
    ],
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  
  //Validación general de login
  if (to.meta.requiresAuth) {
    if (!isAuthenticated()) {
      return next('/login')
    }
  }

  //Validacion de firma de ajustador
  const user = getUser()
  
  if( user.role === 'Ajustador' && user.hasSignature === 'NO' && to.name !== 'signature') {
    return next({ name: 'signature', params : { id : user.ajustadorId } })
  }

  if( user.role === 'Ajustador' && user.hasSignature === 'SI' && to.name === 'signature') {
    return next({ name: 'ajustes' })
  }

  //Validación de roles si se especifican
  if (to.meta.requiresRole) {
    if (!isAuthenticated()) {
      return next('/login')
    }

    const allowedRoles = to.meta.requiresRole
    if (!hasAuthorization(allowedRoles)) {
      return next('/unauthorized')
    }
  }

  next()
})

export default router
